import React, { useState } from 'react';
import { Typography, Box, Paper, useTheme } from '@mui/material';
import { GridContainer, GridItem, Tabs } from '../../components/shared';
import { TAB_TYPES } from '../../constants/CommonConstants';
import UnmappedDataFeedTab from './UnmappedDataFeedTab';
import MissingDataFeedTab from './MissingDataFeedTab';

const displayName = 'ExceptionReporting';

const ExceptionReporting = () => {
  const [unmappedDataFeedCount, setUnmappedDataFeedCount] = useState(0);
  const [missingDataFeedCount, setMissingDataFeedCount] = useState(0);
  const [activeTab, setActiveTab] = useState('1');
  const theme = useTheme();

  const tabs = [
    {
      heading: TAB_TYPES.UNMAPPED_DATA_FEED,
      content: <UnmappedDataFeedTab onCountChange={(count) => setUnmappedDataFeedCount(count)} />,
    },
    {
      heading: TAB_TYPES.MISSING_DATA_FEED,
      content: <MissingDataFeedTab onCountChange={(count) => setMissingDataFeedCount(count)} />,
    },
  ];

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const getActiveTabCount = () => {
    if (activeTab === '1') {
      return unmappedDataFeedCount;
    } else if (activeTab === '2') {
      return missingDataFeedCount;
    }
    return 0;
  };

  const totalExceptions = getActiveTabCount();

  return (
    <React.Fragment>
      <GridContainer>
        <GridItem xs={6} display="flex" alignItems="center">
          <Typography variant="h1">Exception Reporting</Typography>
        </GridItem>
      </GridContainer>
      <Typography variant="h3" style={{ color: theme.palette.secondary.main }}>
        {totalExceptions > 0 ? `${totalExceptions} Exceptions` : ''}
      </Typography>
      <Box mt={2} component={Paper}>
        <Tabs defaultTab="1" tabsData={tabs} onTabChange={handleTabChange} />
      </Box>
    </React.Fragment>
  );
};

ExceptionReporting.displayName = displayName;
export default ExceptionReporting;
